/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Booking Engine
 * Hotel search and booking microservice for Herika SaaS
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetMyProfileApiV1MeProfileGet200,
  HTTPValidationError,
  ModuleStatusEntry,
  OnboardingPayload,
  PatchMyOnboardingApiV1MeOnboardingPatch200
} from '.././schemas';

import { axiosInstance } from '../../axios-instance';
import type { ErrorType , BodyType } from '../../axios-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Aggregate identity payload: user, current_org, memberships, modules.

BOOTSTRAP endpoint: deliberately uses `get_authenticated_user` (JWT
only) instead of `get_auth_context`. The FE calls this BEFORE it knows
which `X-Active-Role` to send — using `get_auth_context` here would be
circular (would require the very role the FE is asking us to reveal).

Two-step resolution against the CP:
  1) Call `/users/me/full-profile` without `org_id` → memberships list.
  2) Pick the bootstrap org (preferring OTA) and re-call WITH `org_id`
     so `current_organization` is populated (org profile, enabled
     modules, **onboarding_completed_at**). Without this, the FE
     router can't tell a returning user from a brand-new one and
     loops them through `/onboarding` even after they've completed it.
 * @summary Get My Profile
 */
export const getMyProfileApiV1MeProfileGet = (
    
 options?: SecondParameter<typeof axiosInstance>,signal?: AbortSignal
) => {
      
      
      return axiosInstance<GetMyProfileApiV1MeProfileGet200>(
      {url: `/api/v1/me/profile`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMyProfileApiV1MeProfileGetQueryKey = () => {
    return [
    `/api/v1/me/profile`
    ] as const;
    }

    
export const getGetMyProfileApiV1MeProfileGetQueryOptions = <TData = Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyProfileApiV1MeProfileGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>> = ({ signal }) => getMyProfileApiV1MeProfileGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyProfileApiV1MeProfileGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>>
export type GetMyProfileApiV1MeProfileGetQueryError = ErrorType<unknown>


export function useGetMyProfileApiV1MeProfileGet<TData = Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>,
          TError,
          Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfileApiV1MeProfileGet<TData = Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>,
          TError,
          Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyProfileApiV1MeProfileGet<TData = Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Profile
 */

export function useGetMyProfileApiV1MeProfileGet<TData = Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfileApiV1MeProfileGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyProfileApiV1MeProfileGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List modules + enabled flag for the user's current org.

Returns the FE-prefixed shape (`module_code`/`module_name`/...) — the CP
response uses bare `code`/`name`/`type`/`is_enabled`. Without this
remap the FE crashes in `.sort((a, b) => a.module_name.localeCompare(...))`
on `undefined.localeCompare(undefined)`.
 * @summary Get My Modules Status
 */
export const getMyModulesStatusApiV1MeModulesStatusGet = (
    
 options?: SecondParameter<typeof axiosInstance>,signal?: AbortSignal
) => {
      
      
      return axiosInstance<ModuleStatusEntry[]>(
      {url: `/api/v1/me/modules-status`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMyModulesStatusApiV1MeModulesStatusGetQueryKey = () => {
    return [
    `/api/v1/me/modules-status`
    ] as const;
    }

    
export const getGetMyModulesStatusApiV1MeModulesStatusGetQueryOptions = <TData = Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyModulesStatusApiV1MeModulesStatusGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>> = ({ signal }) => getMyModulesStatusApiV1MeModulesStatusGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyModulesStatusApiV1MeModulesStatusGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>>
export type GetMyModulesStatusApiV1MeModulesStatusGetQueryError = ErrorType<unknown>


export function useGetMyModulesStatusApiV1MeModulesStatusGet<TData = Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyModulesStatusApiV1MeModulesStatusGet<TData = Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyModulesStatusApiV1MeModulesStatusGet<TData = Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Modules Status
 */

export function useGetMyModulesStatusApiV1MeModulesStatusGet<TData = Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyModulesStatusApiV1MeModulesStatusGet>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyModulesStatusApiV1MeModulesStatusGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Persist onboarding completion + profile preferences for the current org.

Uses `get_auth_context` (read-level) rather than the stricter write variant
because onboarding writes to the organization profile, not to any specific
external_account — so it doesn't need X-External-Id even when the user has
multiple workspaces.
 * @summary Patch My Onboarding
 */
export const patchMyOnboardingApiV1MeOnboardingPatch = (
    onboardingPayload: BodyType<OnboardingPayload>,
 options?: SecondParameter<typeof axiosInstance>,) => {
      
      
      return axiosInstance<PatchMyOnboardingApiV1MeOnboardingPatch200>(
      {url: `/api/v1/me/onboarding`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: onboardingPayload
    },
      options);
    }
  


export const getPatchMyOnboardingApiV1MeOnboardingPatchMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMyOnboardingApiV1MeOnboardingPatch>>, TError,{data: BodyType<OnboardingPayload>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMyOnboardingApiV1MeOnboardingPatch>>, TError,{data: BodyType<OnboardingPayload>}, TContext> => {

const mutationKey = ['patchMyOnboardingApiV1MeOnboardingPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMyOnboardingApiV1MeOnboardingPatch>>, {data: BodyType<OnboardingPayload>}> = (props) => {
          const {data} = props ?? {};

          return  patchMyOnboardingApiV1MeOnboardingPatch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMyOnboardingApiV1MeOnboardingPatchMutationResult = NonNullable<Awaited<ReturnType<typeof patchMyOnboardingApiV1MeOnboardingPatch>>>
    export type PatchMyOnboardingApiV1MeOnboardingPatchMutationBody = BodyType<OnboardingPayload>
    export type PatchMyOnboardingApiV1MeOnboardingPatchMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Patch My Onboarding
 */
export const usePatchMyOnboardingApiV1MeOnboardingPatch = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMyOnboardingApiV1MeOnboardingPatch>>, TError,{data: BodyType<OnboardingPayload>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMyOnboardingApiV1MeOnboardingPatch>>,
        TError,
        {data: BodyType<OnboardingPayload>},
        TContext
      > => {

      const mutationOptions = getPatchMyOnboardingApiV1MeOnboardingPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    